import {
  Image,
  Stack,
  useColorModeValue,
  Input,
  Button,
  Flex,
} from "@chakra-ui/react";
import { useState } from "react";
import {
  BsFillCameraVideoFill,
  BsFillCameraVideoOffFill,
  BsFillMicFill,
  BsMicMuteFill,
} from "react-icons/bs";
import img from "../../assets/livestream_photo.jpeg";
function PrepareMeeting({ setDisplayScreen }) {
  const containerBgColor = useColorModeValue("#F9FAFC", "#020b19");
  const inputBgColor = useColorModeValue("#fff", "#081b2e");
  const [muteMic, setMuteMic] = useState(true);
  const [showCam, setShowCam] = useState(true);

  const inputStyles = {
    p: "25px",
    borderRadius: "10px",
    boxShadow: "3px 8px 13px 0px #8080800f",
    bg: inputBgColor,
    w: "100%",
    fontSize: ".9em",
    color: "#697C94",
  };

  return (
    <Stack direction={"row"} spacing="50px" pr="60px">
      <Stack
        bg={containerBgColor}
        borderRadius={"15px"}
        p="20px"
        alignItems={"center"}
        margin="0 auto"
      >
        <Input
          placeholder="Title"
          type="text"
          name="name"
          mb="20px"
          {...inputStyles}
        />
        <Flex
          position={"relative"}
          w={["100%", "500px", "500px", "500px"]}
          h={["220px", "300px", "300px", "300px"]}
        >
          <Image
            position={"absolute"}
            left="0"
            right="0"
            top="0"
            bottom={"0"}
            borderRadius={"25px"}
            w="100%"
            src={img}
            alt="user live image"
          />
          <Flex
            flexDir={"row"}
            alignItems="center"
            position={"absolute"}
            bottom="5px"
            gap="20px"
            w="100%"
            justifyContent={"center"}
          >
            {muteMic ? (
              <BsMicMuteFill
                cursor="pointer"
                fontSize={"1.5em"}
                color="#E4E4E4"
                onClick={() => setMuteMic((prev) => !prev)}
              />
            ) : (
              <BsFillMicFill
                cursor="pointer"
                fontSize={"1.5em"}
                color="#E4E4E4"
                onClick={() => setMuteMic((prev) => !prev)}
              />
            )}
            {showCam ? (
              <BsFillCameraVideoOffFill
                cursor="pointer"
                fontSize={"1.5em"}
                color="#E4E4E4"
                onClick={() => setShowCam((prev) => !prev)}
              />
            ) : (
              <BsFillCameraVideoFill
                cursor="pointer"
                fontSize={"1.5em"}
                color="#E4E4E4"
                onClick={() => setShowCam((prev) => !prev)}
              />
            )}
          </Flex>
        </Flex>

        <Stack maxW="400px" w="350px" spacing={"25px"}>
          <Button
            mt="20px"
            color="#fff"
            h="50px"
            w="250px"
            bg="#00B90D"
            _hover={{ background: "#00B90D" }}
            alignSelf={"center"}
            borderRadius="15px"
            boxShadow={"lg"}
            onClick={() => setDisplayScreen("group-meeting")}
          >
            Start Meeting <br /> ( leading to 'MeetingControlLargeScreen Cpt')
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default PrepareMeeting;
